import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';
import { IsUUID } from 'class-validator';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { JobNoteOptionInterface } from '../interfaces/job-note-option.interface';
import { OptionDto } from '../../option/dto/option.dto';
import { JobNoteDto } from '../../job-note/dtos/job-note.dto';

@Exclude()
export class JobNoteOptionDto
  extends CommonEntityDto
  implements JobNoteOptionInterface
{
  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated Job Repair ID',
  })
  @IsUUID()
  @Expose()
  optionId!: string;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated User ID',
  })
  @IsUUID()
  @Expose()
  jobNoteId!: string;

  @ApiPropertyOptional({
    type: () => [OptionDto],
    title: 'Job Repair Photos',
    description: 'The Job Repairs Photos associated with this job repair ',
  })
  @Expose()
  option?: OptionDto;

  @ApiPropertyOptional({
    type: () => [JobNoteDto],
    title: 'Job Repair Photos',
    description: 'The Job Repairs Photos associated with this job repair ',
  })
  @Expose()
  jobNote?: JobNoteDto;
}
